import { useRef } from 'react'

export const usePrev = <T>(nextValue: T) => {
  const ref = useRef<T>(nextValue)
  const prevValue = ref.current
  ref.current = JSON.parse(JSON.stringify(nextValue))
  return prevValue
}

